import { render, staticRenderFns } from "./WohnzimmerEG.vue?vue&type=template&id=fff75cee"
import script from "./WohnzimmerEG.vue?vue&type=script&lang=js"
export * from "./WohnzimmerEG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports